import React from 'react';
import { useTranslation } from 'react-i18next';

import CardTitle from 'app/components/Card/CardTitle';
import FormActions from 'app/components/FormActions';
import QueryIndicator from 'app/components/QueryIndicator';
import AlertMessage from 'app/components/AlertMessage';
import { useUpdateCandidateIsLiberalMutation } from 'app/generated/graphql';

type Props = {
  onClose: () => void
  onMutationSuccess: () => void
};

const ProfileAskIsLiberalForm = ({ onClose, onMutationSuccess }: Props) => {
  const { t } = useTranslation();

  const [update, { loading, error }] = useUpdateCandidateIsLiberalMutation();

  const handleSubmit = () => {
    update({
      variables: { isLiberal: true },
      onCompleted() {
        onMutationSuccess();
      },
      onError() {},
    });
  };

  if (loading) {
    return <QueryIndicator />;
  }

  return (
    <>
      <CardTitle>{t('profilePage.profileAskIsLiberalForm.title')}</CardTitle>
      {error && (
      <AlertMessage message={error.message} />
      )}
      <p>{t('profilePage.profileAskIsLiberalForm.subtitle')}</p>
      <p><strong>{t('profilePage.profileAskIsLiberalForm.question')}</strong></p>
      <FormActions
        onCancel={onClose}
        onConfirm={handleSubmit}
        closeLabel={t('profilePage.profileAskIsLiberalForm.deny')}
        submitLabel={t('profilePage.profileAskIsLiberalForm.accept')}
        variant="primary"
      />
    </>
  );
};

export default ProfileAskIsLiberalForm;
